


























import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import { Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  components: { BaseButton }
})
export default class ToolbarDialogButton extends mixins<DialogMixin>(DialogMixin) {
  @Prop({ default: undefined }) icon: string
  @Prop() width: string
  modal: boolean = false
}

